import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.93 1.277H4.821a2.676 2.676 0 0 0-2.67 2.67v8.18a2.676 2.676 0 0 0 2.67 2.67h6.359a2.676 2.676 0 0 0 2.671-2.67v-6.24h.009V5.2Zm2.421 10.85A1.178 1.178 0 0 1 11.18 13.3H4.821a1.171 1.171 0 0 1-1.17-1.17V3.947a1.171 1.171 0 0 1 1.17-1.17h4.43v3.11h3.1Zm-1.731-5.21H5.381a.755.755 0 0 0-.75.75V11.6a.755.755 0 0 0 .75.75h5.239a.755.755 0 0 0 .75-.75V7.667a.755.755 0 0 0-.75-.75Zm-.75 1.96H8.4v-.46h1.47Zm-3.739-.46H6.9v.46h-.77Zm0 1.96H6.9v.47h-.77Zm3.739.47H8.4v-.47h1.47Z';
const draw24px =
  'M16,11.25H8a.75.75,0,0,0-.75.75v6a.75.75,0,0,0,.75.75h8a.76.76,0,0,0,.75-.75V12A.76.76,0,0,0,16,11.25Zm-7.25,1.5h1.58v1.5H8.75Zm0,3h1.58v1.5H8.75Zm6.5,1.5H11.83v-1.5h3.42Zm0-3H11.83v-1.5h3.42ZM20.7,7.64,15,1.89H7.06A3.76,3.76,0,0,0,3.31,5.63V18.37a3.76,3.76,0,0,0,3.75,3.75H17a3.76,3.76,0,0,0,3.75-3.75V7.64ZM19.21,18.37A2.25,2.25,0,0,1,17,20.62H7.06a2.25,2.25,0,0,1-2.25-2.25V5.63A2.25,2.25,0,0,1,7.06,3.38H14V8.64h5.26Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentSpreadsheetIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentSpreadsheet')) as IconWithRender;

DocumentSpreadsheetIcon.displayName = 'DocumentSpreadsheetIcon';
DocumentSpreadsheetIcon.propTypes = Icon.propTypes;
DocumentSpreadsheetIcon.renderIcon = (props) => (
  <DocumentSpreadsheetIcon {...props} />
);
export default DocumentSpreadsheetIcon;
